/**
 * @class reportFilterConstants.
 *
 */
import { tableConstantsFactory } from './tableConstantsFactory';
export default tableConstantsFactory('REPORTFILTER');